<template>
  <div class="login" style="height: 100%">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">
          {{ "【" + member + "】" + $t("editing") + "..." }}
        </h2>
      </div>
      <div class="weui-form__control-area" style="
          max-width: 500px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        ">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("sdwan.virtualIP") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="ip" class="weui-input" ref="appName" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("sdwan.resource") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="resource" class="weui-input" ref="srcPort" />
              </div>
              <div class="weui-cell__ft">
                <button type="button" v-on:click="showTooltip" class="weui-btn_reset weui-btn_icon">
                  <i role="img" alt="帮助" class="js_target weui-icon-info-circle"></i>
                </button>
              </div>
            </div>
            <div v-if="apps.length > 0" class="" style="color: rgb(255, 255, 255);padding-left: 16px;">
              <div class="member-list weui-cells weui-cells_form ">
                <div class="list-header columns is-mobile">
                  <div class="column is-three-fifths">{{ $t("sdwan.member") }}</div>
                  <div class="column is-two-fifths">{{ $t("sdwan.connectStatus") }}</div>
                </div>
                <div v-for="(member, index) in apps" :key="index" class="list-item columns is-mobile">
                  <div class="column member-name column is-three-fifths">
                    {{ member.peerNode }}
                  </div>
                  <div class="column virtual-ip column ">
                    <span v-if="(apps[index].isActive != 1 && apps[index].error == 'peer offline') || isActive(index) != 1"
                      style="font-weight: bold; background-color: rgb(155, 11, 11);">
                      {{ $t("offline") }}
                    </span>
                    <span v-else-if="apps[index].isActive != 1"
                      style="font-weight: bold; background-color: rgb(184, 83, 24);">
                      {{ $t("apps.connecting") }}
                    </span>
                    <span v-else style="font-weight: bold; background-color: rgb(72, 166, 80);">
                      {{ link(index) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" v-on:click="save" href="javascript:">{{ $t("save") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
export default {
  name: "appedit",
  computed: {
    remoteNodes() {
      var nodes = Array.from(this.$store.state.nodes)
      return nodes.filter(
        (node) =>
          node.name != this.$route.params.nodeName && node.name != this.peerNode
      )
    },
  },
  async mounted() {
    await this.loadApps()
    window.debugLog("memapp " + this.member)

    this.ip = this.$store.state.sdwan.Nodes[this.selectedIndex].ip
    this.resource =
      this.$store.state.sdwan.Nodes[this.selectedIndex].resource


  },
  data() {
    return {
      member: "",
      ip: "",
      resource: "",
      selectedIndex: "",
      apps: [],
      requestState: "requesting",
    }
  },
  methods: {
    isActive(index) {
      let isActive = 0
      this.$store.state.nodes.forEach((v) => {
        if (v.name == this.apps[index].peerNode) {
          window.debugLog("isActive ", v)
          isActive = v.isActive
          return
        }
      })
      return isActive
    },
    link(index) {
      window.debugLog("link:", this.apps[index])
      if (this.apps[index].relayMode == "public") {
        return this.$t("apps.relay") + " (" + this.$t("apps.publicNet") + ")"
      } else if (this.apps[index].relayMode == "private") {
        return this.$t("apps.relay") + " (" + this.$t("apps.privateNet") + ")"
      } else {
        if (this.apps[index].linkMode == "ipv6") {
          // ignore ipv4
          return this.$t("apps.directIPv6")
        } else if (this.apps[index].linkMode == "intranet"){
          return this.$t("apps.directIntranet")
        }
        return this.$t("apps.direct")
      }
    },
    showTooltip() {
      weui.alert(this.$t("sdwan.resourceTips"), {
        buttons: [
          {
            label: this.$t("ok"),
            onClick: function () { },
          },
        ],
      })
      return
    },
    save() {
      this.$store.state.sdwan.Nodes[this.selectedIndex].ip = this.ip
      this.$store.state.sdwan.Nodes[this.selectedIndex].resource =
        this.resource
      this.$router.go(-1)
    },
    loadApps: async function () {
      this.requestState = "requesting"
      try {
        await this.$initDataOnce()
        this.selectedIndex = this.$route.params.index
        this.member = this.$store.state.sdwan.Nodes[this.selectedIndex].name
        let res = await axios.get(
          this.$ServerHost +
          "/api/v1/device/" +
          encodeURIComponent(this.member) +
          "/memapps"
        )
        window.debugLog("memapps:", res)
        if (res && res.data.Apps) {
          let _apps = res.data.Apps
          this.apps = _apps.map((app) => {
            let {
              srcPort,
              protocol,
              peerNode,
              peerUser,
              appName,
              dstHost,
              dstPort,
              whitelist,
              peerIP,
              peerNatType,
              relayNode,
              relayMode,
              linkMode,
              isActive,
              enabled,
              connectTime,
              error,
            } = app
            // window.debugLog("got one app", app)
            return {
              error,
              srcPort,
              protocol,
              appName,
              relayNode,
              relayMode,
              linkMode,
              peerNode,
              peerUser,
              dstHost,
              dstPort,
              whitelist,
              peerIP,
              peerNatType,
              isActive,
              enabled,
              nodeName: this.member,
              connectTime: new Date(connectTime).format("yyyy-MM-dd hh:mm:ss"),
            }
          })
          this.apps.sort((appA, appB) => {
            const peerNodeA = appA.peerNode.toLowerCase()
            const peerNodeB = appB.peerNode.toLowerCase()
            if (peerNodeA < peerNodeB) {
              return -1
            }
            if (peerNodeA > peerNodeB) {
              return 1
            }
            return 0
          });
        }
        this.requestState = "end"
        window.debugLog("get memapps:", this.apps)
      } catch (err) {
        this.requestState = "timeout"
      }
    },
  },
}
</script>

<style scoped>
@import "../assets/css/weui.scss";
</style>
